define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/table/AggregateFrom"
], function(declare,lang,_,AggregateFrom) {

	return declare(AggregateFrom, {
		getFormData: function() {
			var fd = this.inherited(arguments);
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateInspectionSection);
			return fd;
		},

		_canAggregateInspectionSection: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of inspection sections that have no batch sections
			var section = this.getParent();
			var nodeURL = ctx.getNodeURL();
			
			return !_.some(section.Tests, function(batchTestUrl) {
				var batchTest = ctx.cache.getNode(batchTestUrl);
				return batchTest.TestSpecRev == nodeURL;
			});
		}
	});
});